import type { AnswerInputProps } from '../QuestionRenderer'

export function LongTextInput({ question, value, onChange, onSubmit }: AnswerInputProps<string>) {
  return (
    <div>
      <textarea
        value={value ?? ''}
        placeholder={question.settings.placeholder ?? '請輸入詳細回覆'}
        maxLength={question.settings.maxLength}
        onChange={(event) => {
          onChange(event.target.value)
          event.currentTarget.style.height = 'auto'
          event.currentTarget.style.height = `${Math.min(event.currentTarget.scrollHeight, 300)}px`
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault()
            onSubmit()
          }
        }}
        className="max-h-[300px] min-h-32 w-full resize-none rounded-md border border-slate-200 bg-white p-4 text-lg outline-none focus:border-[var(--form-accent,#6366F1)] focus:ring-2 focus:ring-indigo-100"
        style={{
          background: 'color-mix(in srgb, var(--form-bg,#F8FAFC) 86%, white)',
          borderColor: 'color-mix(in srgb, var(--form-accent,#6366F1) 28%, transparent)',
          borderRadius: 'var(--form-radius,8px)',
          color: 'var(--form-answer,#334155)',
          fontFamily: 'var(--form-body-font,var(--form-font,Geist))',
          fontSize: 'var(--form-input-size,1.25rem)',
          lineHeight: 'var(--form-line-height,1.55)',
        }}
      />
      {question.settings.maxLength && (
        <div
          className="mt-2 text-right"
          style={{
            color: 'var(--form-answer,#64748B)',
            fontSize: 'var(--form-meta-size,0.9375rem)',
          }}
        >
          {value?.length ?? 0} / {question.settings.maxLength}
        </div>
      )}
    </div>
  )
}
